import React, { useEffect, useState } from 'react';
import { collection, getDocs, query, orderBy } from 'firebase/firestore';
import { db } from '../firebase';
import LoadingAnimation from './LoadingAnimation';
import Footer from './Footer';

const Resources = () => {
  const [resources, setResources] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchResources = async () => {
      try {
        const q = query(collection(db, 'resources'), orderBy('order', 'asc'));
        const snap = await getDocs(q);
        const now = new Date();
        setResources(snap.docs
          .map(doc => ({ id: doc.id, ...doc.data() }))
          .filter(r => {
            const status = r.status || 'published';
            if (status === 'deleted' || status === 'draft') return false;
            if (status === 'scheduled' && r.scheduled_at && r.scheduled_at.toDate() > now) return false;
            return true;
          })
        );
      } catch (err) {
        console.error('Error fetching resources:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchResources();
  }, []);

  const formatDate = (timestamp) => {
    if (!timestamp) return '';
    const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
    return date.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
  };

  return (
    <div className="stt-page">
      <div className="stt-content" style={{ paddingTop: '40px', paddingBottom: '60px' }}>
        <h1 className="stt-page-title">Resources</h1>
        <hr className="divider-gold" style={{ margin: '0 0 32px' }} />

        {loading ? (
          <LoadingAnimation />
        ) : resources.length === 0 ? (
          <p style={{ color: '#888' }}>No resources yet. Check back soon.</p>
        ) : (
          resources.map(resource => (
            <a
              key={resource.id}
              href={resource.url}
              target="_blank"
              rel="noopener noreferrer"
              className="stt-resource-item"
            >
              <p className="stt-resource-title">{resource.title}</p>
            </a>
          ))
        )}
      </div>
      <Footer />
    </div>
  );
};

export default Resources;
